import Axios, { AxiosError, AxiosInstance } from 'axios';
import Cookies from 'js-cookie';

import { NonMemberAuthStorage } from '@/utils';

const { REACT_APP_LINK_API_ENDPOINT, REACT_APP_LINK_API_PROTOCOL, REACT_APP_LINK_API_PORT } =
  process.env;

const BASE_URL = `${REACT_APP_LINK_API_PROTOCOL}://${REACT_APP_LINK_API_ENDPOINT}:${REACT_APP_LINK_API_PORT}`;

export const instance: AxiosInstance = Axios.create({});

instance.interceptors.request.use(function (config) {
  const token = Cookies.get('customer_token') || new NonMemberAuthStorage().get().token;

  config.baseURL = BASE_URL;
  config.withCredentials = true;
  config.headers = config.headers || {};

  if (token) {
    config.headers.Authorization = `token ${token}`;
  }

  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      Cookies.remove('customer_token', {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: '/',
        secure: process.env.NODE_ENV === 'production',
      });
      localStorage.clear();
      sessionStorage.clear();

      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

export * from './error';
